import { BREAKPOINT_LARGE_PX } from '@/settings';
import { css } from 'lit';

export const printProofStyles = css`
  .status {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 12px;
    gap: 16px;
    line-height: 1.25rem;
    flex-direction: column;
    margin: 10px 0;
  }
  :host([part='retail']) .status {
    font-size: 0.875rem;
    border-radius: var(
      --fg-borderradius--sm,
      var(--fg-fallback-borderradius--sm)
    );
  }
  :host([part='wholesale']) .status {
    border-radius: var(
      --fg-borderradius--xs,
      var(--fg-fallback-borderradius--xs)
    );
  }
  .message {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: center;
  }

  @media screen and (min-width: ${BREAKPOINT_LARGE_PX}px) {
    .status {
      padding: 27px 24px;
      flex-direction: row;
    }
    .message {
      justify-content: flex-start;
    }
  }
`;
